import { MenuContainer, Sidebar, Menu, MenuItem, LogoContainer } from "./MenuProduct.style";
import DrReckeweg from '../../assets/Products/Logos/dr-reckeweg-white.png'

const MenuProduct = () => {
  return (
    <MenuContainer>
      <Sidebar>
      <LogoContainer>
          <img src={DrReckeweg} alt="Logo" />
        </LogoContainer>
        <h2>Menu</h2>
        <Menu>
          <MenuItem>Goteros</MenuItem>
          <MenuItem>Jarabes, aceites y soluciones tópicas</MenuItem>
          <MenuItem>Cápsulas</MenuItem>
          <MenuItem>Solución estéril con nebulizador nasal</MenuItem>
          <MenuItem>Procaina Köhler 2%</MenuItem>
          <MenuItem>Inyectables</MenuItem>
          <MenuItem>Sales de Schüssler</MenuItem>
        </Menu>
      </Sidebar>
    </MenuContainer>
  );
};

export default MenuProduct;
